import { useCallback, useMemo, useState } from "react";
import { getAttachmentsActions } from "../../services/api/attachments/attachments.api";

const DELETE_UNAVAILABLE_TITLE = "Não é possível remover. Motivo(s):";
const RELEASE_UNAVAILABLE_TITLE = "Não é possível liberar. Motivo(s):";
const UNRELEASE_UNAVAILABLE_TITLE =
  "Não é possível revogar a liberação. Motivo(s):";

export function useAttachmentActions() {
  const [actions, setActions] = useState([]);

  const fetchAttachmentActions = useCallback(async (ids = []) => {
    if (!ids.length) return;

    const response = await getAttachmentsActions({
      attachmentIds: ids,
    });

    setActions(response || []);
  }, []);

  const byId = useMemo(() => {
    const map = {};

    actions.forEach((action) => {
      const id = action.attachmentId;

      if (!map[id]) map[id] = {};

      map[id][action.actionType] = action;
    });

    return map;
  }, [actions]);

  const getAction = (id, type) => byId?.[id]?.[type];

  const canDelete = (id) => getAction(id, "Delete")?.available;
  const canDownload = (id) => getAction(id, "Download")?.available;
  const canReleaseChannel = (id) => getAction(id, "ReleaseChannel")?.available;
  const canUnReleaseChannel = (id) =>
    getAction(id, "UnReleaseChannel")?.available;
  const canShare = (id) => getAction(id, "Share")?.available;

  const getDeleteReason = (id) => getAction(id, "Delete")?.observation?.reason;

  const getUnavailableMessage = (id, type, title) => {
    const action = getAction(id, type);

    if (!action || action.available) {
      return null;
    }

    const reason = action.observation?.reason;

    const reasons = [
      ...new Set(
        Array.isArray(reason) ? reason.filter(Boolean) : reason ? [reason] : []
      ),
    ];

    return {
      title,
      reasons,
    };
  };

  const getDeleteUnavailableMessage = (id) =>
    getUnavailableMessage(id, "Delete", DELETE_UNAVAILABLE_TITLE);

  const getReleaseUnavailableMessage = (id) =>
    getUnavailableMessage(id, "ReleaseChannel", RELEASE_UNAVAILABLE_TITLE);

  const getUnReleaseUnavailableMessage = (id) =>
    getUnavailableMessage(id, "UnReleaseChannel", UNRELEASE_UNAVAILABLE_TITLE);

  return {
    actions,
    fetchAttachmentActions,

    canDelete,
    canDownload,
    canReleaseChannel,
    canUnReleaseChannel,
    canShare,
    getDeleteReason,
    getDeleteUnavailableMessage,
    getReleaseUnavailableMessage,
    getUnReleaseUnavailableMessage,
  };
}
